import React, { useState, useContext, useMemo } from 'react';
import { ButtonPrimary, Spinner } from '../StyledComponent';

import BaseComponentChangeData from '../BaseComponentChangeData';

import { Context } from '../../services/auth';

import { ContainerChangePassword } from './styles';

import PasswordVerification from '../PasswordVerification';
import { passwordsEquals } from '../../Utils/validatePassword';
import { useHistory } from 'react-router-dom';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';
import HeaderSection from '../HeaderSection';
import MessagePopUp from '../MessagePopup';
import InputPassword from '../InputPassword';
import Cognito from '../../Amplify';

const ChangeEmailPassword = ({ cpf, email }) => {
  const { tema } = useContext(ContextoListaApartamentos);
  const history = useHistory();

  const [newPassword, setNewPassword] = useState('');

  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(false);

  const [approved, setApproved] = useState(false);

  const [success, setSuccess] = useState(false);

  const { mudaPassword } = useContext(Context);

  const arePasswordEquals = useMemo(() => {
    return passwordsEquals(newPassword, confirmNewPassword);
  }, [newPassword, confirmNewPassword]);

  const passwordInvalid = useMemo(() => {
    return (
      newPassword === '' ||
      confirmNewPassword === '' ||
      newPassword != confirmNewPassword ||
      !approved
    );
  }, [newPassword, confirmNewPassword, approved]);

  async function signInCognitoAndChangePassword() {
    try {
      setLoading(true);

      await Cognito.signIn(email, cpf);

      const resultChangePassword = await mudaPassword({
        password: cpf,
        newPassword,
      });

      if (
        resultChangePassword === 'SUCCESS' ||
        resultChangePassword === undefined
      ) {
        setSuccess(true);
        return;
      }

      setError(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function handleSignOut() {
    await Cognito.signOut();
    history.push('/');
  }

  return (
    <ContainerChangePassword>
      <BaseComponentChangeData>
        <HeaderSection
          notShowButton
          tema={tema}
          title={'Altere sua senha'}
          subtitle={
            'Para modificar o seu e-mail, precisamos que você crie uma nova senha para acessar o Pode Morar:'
          }
        />
        <div className='containerInputs'>
          <InputPassword
            id='txtNewPassword'
            password={newPassword}
            setPassword={setNewPassword}
            labelName='Nova senha'
            placeholder='NOVA SENHA'
            marginTop={16}
            error={!arePasswordEquals}
            disabled={loading}
          />

          <InputPassword
            id='txtConfirmNewPassword'
            password={confirmNewPassword}
            setPassword={setConfirmNewPassword}
            labelName='Confirme a nova senha'
            placeholder='CONFIRME SUA SENHA'
            error={!arePasswordEquals}
            errorMessage={'As senhas devem ser iguais'}
            marginTop={16}
            disabled={loading}
          />
        </div>

        <PasswordVerification
          password={newPassword}
          approved={approved}
          setApproved={setApproved}
        />

        <div className='container-buttons'>
          <ButtonPrimary
            id='btnCancelarAlteracaoSenha'
            onClick={() => history.push('/meu-perfil')}
            tema={tema}
            light
            fullWidth
            disabled={loading}
          >
            Cancelar
          </ButtonPrimary>

          <ButtonPrimary
            id='btnConfirmChangePassword'
            disabled={passwordInvalid || loading}
            onClick={signInCognitoAndChangePassword}
            tema={tema}
            fullWidth
          >
            {loading ? (
              <>
                <span>CARREGANDO...</span> <Spinner />
              </>
            ) : (
              <span>ALTERAR SENHA</span>
            )}
          </ButtonPrimary>
          {success && (
            <MessagePopUp
              title={'E-mail alterado com sucesso!'}
              message={
                'Agora você deve acessar a sua conta com o seu novo email'
              }
            >
              <ButtonPrimary fullWidth tema={tema} onClick={handleSignOut}>
                FECHAR
              </ButtonPrimary>
            </MessagePopUp>
          )}
          {error && (
            <MessagePopUp
              title={'Erro!'}
              message={
                'Ocorreu um erro ao alterar seu email. Por favor tente novamente!'
              }
              error
            >
              <ButtonPrimary
                fullWidth
                tema={tema}
                onClick={() => setError(false)}
              >
                FECHAR
              </ButtonPrimary>
            </MessagePopUp>
          )}
        </div>
      </BaseComponentChangeData>
    </ContainerChangePassword>
  );
};

export default ChangeEmailPassword;
